import React, { useState } from "react";
import ContactModal from "./ContactModal";
import "./Hero.css";

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="hero">
      {/* Background Effects */}
      <div className="hero-bg-effects">
        {/* Purple Blur Effect */}
        <div className="blur-effect blur-purple" />

        {/* Teal Blur Effect */}
        <div className="blur-effect blur-teal" />

        {/* Main Background Image */}
        <div className="hero-bg-image" />

        {/* Main Hero Image */}
        <div className="hero-main-image">
          <img src="/images/hero.png" alt="Hero Background" />
        </div>

        {/* Glass Effect Image */}
        <div className="hero-glass-effect">
          <img src="/images/glass-effect.png" alt="Glass Effect" />
        </div>

        {/* Glass Effect Bars */}
        {/* <div className="glass-effects">
          {Array.from({ length: 12 }, (_, i) => (
            <div key={i} className="glass-bar" />
          ))}
        </div> */}

        {/* Holo Blobs */}
        <div className="holo-blobs" />
      </div>

      {/* Hero Content */}
      <div className="hero-content">
        <div className="hero-text-container">
          <h1 className="hero-title">Brillance, Livrée</h1>
          <p className="hero-subtitle">
            Votre partenaire technologique visionnaire pour des produits
            numériques qui comptent.
          </p>
          <p className="hero-description">
            Nestia est une agence digitale qui accompagne startups et
            entreprises dans la création d'expériences uniques : branding,
            design UI/UX, développement web et mobile.
          </p>
        </div>

        <button className="hero-cta" onClick={() => setIsModalOpen(true)}>
          <span>Donnons vie à votre idée</span>
          <img
            src="/icons/arrow-right.svg"
            alt="Arrow"
            className="hero-arrow-icon"
          />
        </button>
      </div>

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
};

export default Hero;
